import { createContext, useContext } from 'react';
import PageStore from './pageStore';
import CourseStore from './courseStore';
import OwnerStore from './ownerStore';
import PropertyStore from './propertyStore';
import UserStore from './user/userStore';
import UnsplashStore from './media/UnsplashStore';
import YoutubeStore from './media/YoutubeStore';
import VimeoStore from './media/VimeoStore';
import MediaLibraryStore from './mediaLibrary/mediaLibraryStore';
import ImageEditorStore from './media/imageEditorStore';
import AdminStore from './adminStore';
import WalkthroughStore from './walkthroughStore';
import PreviewStore from './previewStore';
import ContentStore from './contentStore';
import CourseWizardStore from './coursewizardStore';
import OpenAIStore from './openAIStore';
import EnquiryStore from './enquiryStore';
import UserSettingStore from './user/userSettingStore';
import PublishStore from './publishStore';
import SynthesiaStore from './media/SynthesiaStore';
import DocsStore from './docsStore';
import AiSessionStore from './aiSession/aiSessionStore';
import { createAiSessionStore } from './aiSession/createAiSessionStore';
import MediaGenerationStore from './mediaGeneration/mediaGenerationStore';
import { createMediaGenerationStore } from './mediaGeneration/createMediaGenerationStore';

interface Store {
  ownerStore: OwnerStore;
  courseStore: CourseStore;
  pageStore: PageStore;
  propertyStore: PropertyStore;
  userStore: UserStore;
  unsplashStore: UnsplashStore;
  youtubeStore: YoutubeStore;
  vimeoStore: VimeoStore;
  synthesiaStore: SynthesiaStore;
  mediaLibraryStore: MediaLibraryStore;
  imageEditorStore: ImageEditorStore;
  adminStore: AdminStore;
  walkthroughStore: WalkthroughStore;
  previewStore: PreviewStore;
  contentStore: ContentStore;
  coursewizardStore: CourseWizardStore;
  openAI: OpenAIStore;
  enquiryStore: EnquiryStore;
  userSettingStore: UserSettingStore;
  publishStore: PublishStore;
  docsStore: DocsStore;
  aiSessionStore: AiSessionStore;
  mediaGenerationStore: MediaGenerationStore;
}

export const store: Store = {
  ownerStore: new OwnerStore(),
  courseStore: new CourseStore(),
  pageStore: new PageStore(),
  propertyStore: new PropertyStore(),
  userStore: new UserStore(),
  unsplashStore: new UnsplashStore(),
  youtubeStore: new YoutubeStore(),
  vimeoStore: new VimeoStore(),
  synthesiaStore: new SynthesiaStore(),
  mediaLibraryStore: new MediaLibraryStore(),
  imageEditorStore: new ImageEditorStore(),
  adminStore: new AdminStore(),
  walkthroughStore: new WalkthroughStore(),
  previewStore: new PreviewStore(),
  contentStore: new ContentStore(),
  coursewizardStore: new CourseWizardStore(),
  openAI: new OpenAIStore(),
  enquiryStore: new EnquiryStore(),
  userSettingStore: new UserSettingStore(),
  publishStore: new PublishStore(),
  docsStore: new DocsStore(),
  aiSessionStore: createAiSessionStore(),
  mediaGenerationStore: createMediaGenerationStore(),
};

export const StoreContext = createContext(store);

export function useStore() {
  return useContext(StoreContext);
}
